module.exports = __webpack_public_path__ + "static/jest-9edcb5106c553737a172ec833810fe2e.png";